import { accountActions } from './accountActions';
import { categorySourceActions } from './categorySourceActions';
import { appConfigAction } from './common/appConfigAction';
import { commonActions } from './commonActions';
import { dictionaryActions } from './dictionaryAction';
import { notifyActions } from './notify/notifyAction';
import { uploadActions } from './upload-file/uploadActions';
import { danhMucActionsWrapper } from './danh-muc/danhMucActionsWrapper';
import { thoiKhoaBieuActionsWrapper } from './thoi_khoa-bieu/thoiKhoaBieuActionsWrapper';
import { diemDanhActions } from './diem-danh/diemDanhActions';
import { diemDanhStatusActions } from './diem-danh/diemDanhStatusActions';

export const actions = {
    account: accountActions,
    appConfig: appConfigAction,
    categorySource: categorySourceActions,
    common: commonActions,
    dictionary: dictionaryActions,
    uploadFile: uploadActions,
    notify: notifyActions,
    danhMucWrapper: danhMucActionsWrapper,
    thoiKhoaBieuWrapper: thoiKhoaBieuActionsWrapper,
    diemDanh: diemDanhActions,
    diemDanhStatus: diemDanhStatusActions,
}

